module.exports = __webpack_public_path__ + "img/gif.09868df2.svg";